import React from 'react';
import { motion } from 'framer-motion';
interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  variant?: 'light' | 'dark';
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  variant = 'light'
}: Props) {
  const isDark = variant === 'dark';
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`} data-id="element-669">
      {eyebrow && <div className={`flex items-center gap-2 ${align === 'center' ? 'justify-center' : ''} mb-4`} data-id="element-670">
          <span className="h-px w-8 bg-gold" data-id="element-671" />
          <span className={`font-mono text-xs tracking-[0.2em] uppercase ${isDark ? 'text-gold' : 'text-gold-deep'}`} data-id="element-672">
            {eyebrow}
          </span>
        </div>}
      <h2 className={`font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight ${isDark ? 'text-white' : 'text-navy-deep'}`} data-id="element-673">
        {title}
      </h2>
      {subtitle && <p className={`mt-5 text-base md:text-lg leading-relaxed ${isDark ? 'text-slate-300' : 'text-steel'}`} data-id="element-674">
          {subtitle}
        </p>}
    </motion.div>;
}